{
  "auth": {
    "resetPassword": "Reset your password",
    "cancel": "Cancel",
    "send": "Send",
    "email": "Email",
    "password": "Password",
    "login": "Login",
    "confirmPassword": "Confirm password",
    "save": "Save",
    "emailValid": "Valid email required",
    "passwordsDifferent": "Passwords do not match",
    "connect": "Connect!",
    "forgotPassword": "Forgot password?",
    "noCompte": "No account yet?",
    "passwordNotGood": "Invalid password",
    "passwordValid": "Invalid password (minimum 12 characters, containing uppercase letter, lowercase letter, number and special character)",
    "rememberMe": "Remember me",
    "register": "Register!",
    "lastName": "Last name",
    "firstName": "First name",
    "phone": "Phone number",
    "signUp": "Sign up",
    "alreadyHaveAccount": "Already have an account?",
    "phoneValid": "Phone number required",
    "lastNameValid": "Last name required",
    "firstNameValid": "First name required",
    "clientsProjects": "Clients",
    "toast-newpassword": "A password reset email has been sent to you. Please check your inbox.",
    "passwordResetSuccess": "Your password has been successfully reset. You can now log in.",
    "loading": "Loading..."
  },
  "client": {
    "noClient": "You don't have any client.",
    "create": "Create a client",
    "title": "Clients",
    "form": {
      "title": "Create a client",
      "editTitle": "Edit a client",
      "uploadLogo": "Upload a logo",
      "dragAndDrop": "Drag and drop file here",
      "orChooseFile": "or choose a file",
      "clientName": "Client name",
      "clientEmail": "Client email",
      "cancel": "Cancel",
      "save": "Save",
      "nameRequired": "Client name is required",
      "emailRequired": "Client email is required"
    },
    "deleteTitle": "Delete client",
    "deleteMessage": "Are you sure you want to delete the client {{name}}?",
    "deleteSuccess": "Client deleted successfully",
    "delete": "Delete",
    "updateSuccess": "Client updated successfully",
    "createSuccess": "Client created successfully",
    "notFound": {
      "title": "Client not found",
      "message": "This client does not exist or you don't have access to it.",
      "backToHome": "Back to home"
    }
  },
  "demo": {
    "reset": "Reset demo",
    "resetSuccess": "Demo reset",
    "resetError": "Demo reset failed",
    "resetConfirm": "Reset all demo data? This is destructive.",
    "resetConfirmTitle": "Reset demo"
  },
  "project": {
    "notFound": {
      "title": "Project not found",
      "message": "This project does not exist or you don't have access to it.",
      "backToHome": "Back to home"
    },
    "emptyNetwork": {
      "title": "Empty network",
      "message": "This network has nothing to display yet. Complete it from the settings (tracks and segments) to start planning.",
      "action": "Go to settings"
    },
    "emptyWindow": {
      "title": "No data in this window",
      "message": "The selected PK window contains nothing to display. Widen the range from the controls above, or go back to the whole network.",
      "action": "Show the whole network"
    }
  },
  "projectList": {
    "selectNetwork": "Select a network",
    "noNetwork": "No network available."
  },
  "linearView": {
    "pkStart": "PK start",
    "pkEnd": "PK end",
    "customRange": "Custom range",
    "orCustomRange": "Or custom range",
    "granularity": "Step",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "viewSettings": "View settings",
    "showProtectionZones": "Show protection zones",
    "shownZones": "Shown zones",
    "noTrackInWindow": "No track in this PK range.",
    "sectors": "Sectors",
    "subSectors": "Sub-sectors",
    "geoMarkers": "Markers",
    "buildings": "Buildings",
    "switches": "Switches",
    "allTracks": "All tracks",
    "mainTracks": "Main tracks",
    "byTrack": "By track",
    "trackCount": "{{count}} tracks",
    "trackFilterTooltip": "Filter tracks",
    "defaultRangeTitle": "Default linear view range",
    "defaultRangeDescription": "The PK range the linear views open on when no sector or custom range is active. Applies to everyone on this network.",
    "defaultPkStart": "Default PK start",
    "defaultPkEnd": "Default PK end",
    "networkExtentHint": "Network extent: {{start}} – {{end}}",
    "defaultRangeOutsideExtent": "This range extends beyond the network extent — it will be clamped to the extent when applied.",
    "defaultRangePartial": "Both bounds are required (or leave both empty to clear)",
    "defaultRangeNotAnInteger": "Bounds must be whole numbers",
    "defaultRangeNegative": "Bounds must be zero or more",
    "defaultRangeEqualBounds": "PK start and PK end must be different",
    "preferencesSavedSuccess": "Preferences saved",
    "preferencesSavedError": "Could not save the preferences",
    "dayPending": "Pending"
  },
  "filter": {
    "zoneKind": "Shown zones",
    "zoneKindAll": "All",
    "zoneKindSimple": "Simple zones",
    "zoneKindGroup": "Groups"
  },
  "settings": {
    "groupGeneral": "General",
    "groupProtections": "Protections",
    "groupTeams": "Teams & resources",
    "clientScopedNote": "Setting shared by every project of the client.",
    "preferences": "Preferences",
    "previewLinear": "Linear view preview",
    "previewSynoptic": "Synoptic preview",
    "synopticTitle": "Synoptic",
    "synopticContradiction": "Switches contradicting the track order: {{switches}}",
    "synopticOffTrack": "Switches outside their track segments: {{switches}}",
    "synopticUnlinked": "Switches missing track A or B, ignored: {{switches}}"
  },
  "synoptic": {
    "activityDetails": "View activity details",
    "contradiction": "Track order contradicts another switch",
    "offTrack": "PK outside the track segments",
    "dayBanner": "The synoptic view shows one day only — showing {{date}}",
    "dayActivities": "Activities of the day",
    "dayLegend": "All the day's protections are shown. Hover an activity to highlight only its own.",
    "dayNoActivity": "No activity that day",
    "dayNoMatch": "No activity matches the filters",
    "shownActivities": "Shown activities",
    "displayedTracks": "Displayed tracks",
    "displayedProtections": "Displayed protections"
  },
  "switch": {
    "nameColumn": "Name"
  },
  "common": {
    "cancel": "Cancel",
    "expand": "Expand {{name}}",
    "collapse": "Collapse {{name}}",
    "save": "Save",
    "edit": "Edit",
    "loading": "Loading...",
    "delete": "Delete",
    "restore": "Restore",
    "moreActions": "More actions",
    "confirm": "Confirm",
    "create": "Create",
    "search": "Search",
    "choose": "Choose...",
    "close": "Close",
    "clear": "Clear",
    "selectAll": "Select all",
    "deselectAll": "Deselect all",
    "tablePagination": "{{from}} - {{to}} of {{count}}",
    "print": "Print",
    "printDayViewOnly": "Printing is only available in 24h (day) view",
    "printActivitiesDocTitle": "T-ops activities export {{date}}",
    "noResult": "No results.",
    "back": "Back",
    "saveAndLeave": "Save and leave",
    "leaveUnsavedTitle": "Your last changes are not saved",
    "leaveUnsavedMessage": "Leaving now discards those changes. Leave anyway, or stay and save.",
    "leaveAnyway": "Leave anyway",
    "unsavedChanges": "Unsaved changes"
  },
  "days": {
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday",
    "sunday": "Sunday"
  },
  "permissions": {
    "forbiddenMessage": "You do not have the required permissions to access this page.",
    "forbiddenTitle": "Access forbidden",
    "goBack": "Go back",
    "notAllowed": "Action not allowed"
  },
  "popup": {
    "cancel": "Cancel",
    "save": "Save"
  },
  "dictionary": {
    "title": "Wording management",
    "tableTitle": "Terms Update",
    "id": "ID",
    "frVersion": "Version FR",
    "enVersion": "Version EN",
    "originVersion": "Origin version"
  },
  "error": {
    "notFound": "Not found",
    "atLeastOneMember": "Pick at least one member zone",
    "unauthorized": "Unauthorized",
    "forbidden": "Forbidden",
    "badRequest": "Bad request",
    "serverError": "Server error",
    "missingSector": "Please fill in all sector fields or check for overlapping/missing sectors",
    "zodError": "Please check the required fields",
    "modificationError": "An error occurred while updating",
    "deleteError": "An error occurred while deleting",
    "creationError": "An error occurred while creating",
    "createError": "An error occurred while creating",
    "overlapActivity": "Overlap detected with existing activities",
    "pkNotOK": "PK must be between {{kmMin}} and {{kmMax}}",
    "pkNotOnTrack": "PK is not on any segment of track {{tracks}}",
    "pkNotOnNetwork": "PK is not on any segment of the network",
    "form": "Some fields are invalid",
    "kmValidationFailed": "Some kilometers are invalid. The kilometers must be inside the project limits and in the same direction.",
    "kmOutOfBounds": "The kilometer {{km}} is out of the project range ({{kmStart}}-{{kmEnd}}).",
    "kmOrderInvalid": "The kilometers order is invalid for this project.",
    "required": "This field is required",
    "fieldRequired": "This field is required",
    "chooseDay": "Pick at least one day.",
    "describeActivity": "Describe the activity in a few words.",
    "chooseHolder": "Pick at least one holder.",
    "chooseTeam": "Pick a team.",
    "enterKmStart": "Enter the start PK.",
    "enterKmEnd": "Enter the end PK.",
    "pkOutOfNetwork": "Outside the network ({{0}} to {{1}}).",
    "sectionRequired": "Add at least one section: a track and a PK range.",
    "sectionIncomplete": "A section is missing one of its PKs.",
    "pkStartEqualpkEnd": "Start should be different than end.",
    "atLeastOneSegment": "Add at least one segment",
    "atLeastOneTrack": "At least one track must be selected.",
    "segmentValidationFailed": "Invalid geometry for this project",
    "invalidEmail": "Invalid email",
    "infoErrorAuthor": "Invalid author",
    "infoErrorPhone": "Invalid phone number",
    "updateError": "Error during update",
    "invalidResetToken": "Invalid reset token",
    "invalidTokenRegister": "Invalid registration token",
    "emailAlreadyUsedRegister": "This email is already used",
    "emailNotFound": "Email not found",
    "rangeNotOnSingleSegment": "This range spans multiple track segments. Please check the range limits.",
    "activityOutOfTrackBounds": "The activity extends beyond the bounds of the track it sits on.",
    "taskLabelTooLong": "Label too long ({{max}} characters max)",
    "jobScopeRejected": "The job scope could not be saved. Reopen the activity and try again."
  },
  "userList": {
    "list": "List of users",
    "add": "Invite / Create a user",
    "name": "Username",
    "email": "Email",
    "invitationError": "An error occurred while sending the invitation",
    "invitationSuccess": "The invitation has been sent successfully",
    "emailAlreadyExists": "The email already exists",
    "noRoles": "No roles assigned",
    "networkRoles": "Network roles",
    "networkFallback": "Unknown network",
    "resendInvitation": "Resend invitation",
    "resendInvitationSuccess": "Invitation resent successfully",
    "resendInvitationError": "Error resending invitation",
    "statsTooltip": "User counts (indicative billing)",
    "statsTitle": "Billing (indicative)",
    "statsRoles": "Roles",
    "statsUsers": "users",
    "statsAccounts": "Accounts",
    "statsActivated": "Activated",
    "statsPending": "Not activated",
    "statsLoading": "Loading…",
    "filterByRole": "Filter by role",
    "filterByActivation": "Filter by activation status",
    "accountActivated": "Activated accounts",
    "accountPending": "Pending accounts"
  },
  "newUser": {
    "title": "Invite / Create new user",
    "mail": "Email",
    "role": "Role",
    "roleUser": "User",
    "roleOPC": "OPC",
    "clients": "Clients",
    "errorClient": "Please select at least one client",
    "errorProjectRoles": "Please select at least one project role",
    "cancel": "Cancel",
    "save": "Save",
    "firstName": "First name",
    "firstNamePlaceholder": "First name",
    "lastName": "Last name",
    "lastNamePlaceholder": "Last name",
    "phone": "Phone",
    "project": "Project",
    "projectRoles": "Project roles",
    "addRole": "Add role",
    "noProjectRoles": "No project roles",
    "noProjectRolesHint": "Add at least one project role",
    "errorNetworkRoles": "Please select at least one network role",
    "network": "Network",
    "networkRoles": "Network roles",
    "noNetworkRoles": "No network roles",
    "noNetworkRolesHint": "Add at least one network role"
  },
  "updateUser": {
    "title": "Modify a user",
    "firstName": "Firstname",
    "lastName": "Lastname",
    "firstNameError": "Firstname invalid",
    "lastNameError": "Lastname invalid",
    "telephone": "Telephone number",
    "telephoneError": "Telephone invalid",
    "confirmDelete": "Are you sure you want to delete this user?",
    "delete": "Delete user",
    "deleteError": "Error deleting user",
    "deleteSuccess": "User deleted successfully",
    "email": "Email address",
    "success": "User updated successfully",
    "project": "Project",
    "projectRoles": "Project roles",
    "addRole": "Add role",
    "noProjectRoles": "No project roles",
    "noProjectRolesHint": "No role assigned",
    "errorProjectSelection": "Please select a project",
    "errorNetworkSelection": "Please select a network",
    "network": "Network",
    "networkRoles": "Network roles",
    "noNetworkRoles": "No network roles",
    "noNetworkRolesHint": "No role assigned",
    "error": "Error during update"
  },
  "general": {
    "resourceCalendar": "Resources",
    "previous": "Previous",
    "today": "Today",
    "next": "Next",
    "week": "Week"
  },
  "resource": {
    "setUnavailability": "Set unavailability",
    "editUnavailability": "Edit unavailability",
    "unavailabilityDetails": "Unavailability details",
    "noNote": "No note",
    "startDate": "Start date",
    "endDate": "End date",
    "note": "Note",
    "periods": "Periods",
    "unavailabilityCreated": "Unavailability created",
    "unavailabilityCreateError": "Error creating unavailability",
    "unavailabilityUpdated": "Unavailability updated",
    "unavailabilityUpdateError": "Error updating unavailability",
    "unavailabilityDeleted": "Unavailability deleted",
    "unavailabilityDeleteError": "Error deleting unavailability"
  },
  "dashboard": {
    "menuOverview": "Dashboard",
    "overviewTitle": "Dashboard",
    "periodLabel": "Period",
    "periodMaxHelper": "Maximum range is 31 days.",
    "coverageLabel": "Coverage:",
    "kpiTotalActivities": "Activities in period",
    "kpiToApprove": "To approve",
    "byStatusTitle": "By status",
    "byActivityTypeTitle": "By activity type",
    "byTeamTitle": "By team",
    "legendDeleted": "Deleted",
    "legendCancelled": "Cancelled",
    "otherSlice": "Other",
    "noData": "No data for this period",
    "weeklyChartTitle": "Activities per day",
    "reportsChartTitle": "Reports per day",
    "legendValidated": "Approved",
    "legendToApprove": "Pending",
    "todayMarker": "Today"
  },
  "activityList": {
    "period": "Period",
    "periodEmptyPrompt": "Pick a start and end date to see activities over a period.",
    "periodCapped": "A period cannot exceed {{days}} days — the selected range was shortened.",
    "periodBanner": "The linear view can't display periods — switched to week {{week}}."
  },
  "tooltip": {
    "periodView": "Period view"
  },
  "activityForm": {
    "groupModificationWarning": "Applies to all activities in the group. Individual changes and history will be lost.",
    "followingModificationWarning": "Applies to this activity and all following ones. Individual changes and history will be lost.",
    "entryVoie": "Entry track(s)",
    "exitVoie": "Exit track(s)",
    "voiePlaceholder": "-",
    "deleteReport": "Delete the report",
    "deleteReportTitle": "Delete this report?",
    "deleteReportMessage": "This shift's progress and comment will be lost. This cannot be undone.",
    "reportDeleted": "Report deleted",
    "reportDeleteError": "The report could not be deleted",
    "laterReportsExist": "At least one later report already exists for this activity. If you change this day's values, they keep theirs; only the change shown for those days is recomputed.",
    "activityTab": "Activity",
    "whoSectionTitle": "Who",
    "requestedBy": "Requested by",
    "companyPlaceholder": "Company name",
    "localisationTab": "Location",
    "nextTab": "Next: {{0}}",
    "protectionTab": "Protections",
    "protectionsTitle": "Requested protections",
    "protectionsHelper": "One row per protection type. A protection zone chosen in the Location tab shows up here by itself.",
    "noProtectionsHelp": "If the activity needs no protection, leave this tab empty: nothing is required here. Otherwise add a protection, choose its type, then the zone(s) to protect.",
    "missingFieldsToast": "{{0}} fields are missing on the {{1}} tab: {{2}}.",
    "missingFieldToast": "One field is missing on the {{0}} tab: {{1}}.",
    "sectionsMissingToast": "The Location tab also needs at least one section.",
    "protectionIncompleteToast": "A protection has no zone (Protections tab).",
    "noTasksOnThisJobOnce": "No task on this activity: its dates carry no progress.",
    "demandKmStart": "Start (PK)",
    "demandKmEnd": "End (PK)",
    "demandWorkZoneExtentHint": "The chosen zones fill in the start and end; you can correct them.",
    "demandProtectionComment": "Comment for the protections",
    "dateCount": "{{count}} date(s)",
    "rangesColumn": "PK ranges",
    "buildingsField": "Building(s)",
    "movementBlockTitle": "Route",
    "extentTitle": "Extent",
    "buildingsTitle": "Buildings",
    "accessHelper": "Where vehicles enter and leave. The trip to the sections is added automatically on the linear view.",
    "accessHelperMovement": "Where the vehicle enters and leaves. The movement's start and end follow from them.",
    "movementExtentHint": "In the direction of travel. Swap them if the vehicle runs the other way.",
    "enclosureExtentHint": "Without a zone, the access points fill them in.",
    "synopticPreviewTitle": "Network preview",
    "synopticPreviewSectionsHint": "Sections will appear here as soon as they are computed.",
    "synopticPreviewProtectionsHint": "Requested protections will appear here."
  },
  "referential": {
    "trackIsMain": "Main track",
    "trackCreated": "Track created",
    "trackUpdated": "Track updated",
    "trackDeleted": "Track deleted",
    "trackCreateError": "The track could not be created",
    "trackUpdateError": "The track could not be updated",
    "trackInUseError": "This track is still used by other elements (switches, windows, activities, zones…)",
    "segmentCreated": "Segment added",
    "segmentUpdated": "Segment updated",
    "segmentDeleted": "Segment deleted",
    "segmentSaveError": "The segment could not be saved",
    "connectionCreated": "Connection declared",
    "connectionUpdated": "Connection updated",
    "connectionDeleted": "Connection deleted",
    "connectionSaveError": "The connection could not be saved",
    "connectionDerivedError": "This connection comes from a project junction: delete the junction to remove it"
  },
  "junction": {
    "createSuccess": "Junction created",
    "updateSuccess": "Junction updated",
    "deleteSuccess": "Junction deleted",
    "noJunction": "No junction on this network"
  },
  "reportList": {
    "periodCapped": "The Reports view only shows the first {{days}} selected days.",
    "cellDelta": "{{delta}}%",
    "cellProgressAfter": "({{after}}%)",
    "taskWeight": "×{{weight}}"
  }
}
